/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRemediationConfigureRequest extends models.PolicyRemediationBase {
    getFixupPrototypeFunction() { return PolicyRemediationConfigureRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyRemediationConfigureRequest>): PolicyRemediationConfigureRequest {
        let obj = Object.assign(new PolicyRemediationConfigureRequest(), model);
        PolicyRemediationConfigureRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRemediationConfigureRequest>): PolicyRemediationConfigureRequest {
        if (!model) return null;
        return PolicyRemediationConfigureRequest.newInstance(<PolicyRemediationConfigureRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRemediationConfigureRequest) {
        if (!obj) return;

        models.PolicyRemediationConfigureRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRemediationConfigureRequest): boolean {
        if (models.PolicyRemediationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyRemediationConfigureRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Enable or disable auto-remediation for this policy
     */
    auto_remediation_status: models.PolicyAutoRemediationStatus;

}
